import { Button, Space } from "antd";
import { PageHeader } from '@ant-design/pro-components';

import {
  CheckOutlined,
  ClearOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { maskCpf } from "../../../utils/maskFunctions";
import { modalApi } from "../../../config/AntdGlobalProvider";
import { apiCand } from "../../../services/apiCand";
import { IErroApi } from "../../../Interfaces/Interfaces";
import { errorMessage, successMessage } from "../../../utils/messages";
import { limparResultadoSalvo } from "../../../utils/contextoPesquisa";
import TelaDataDeExercicio from "./TelaDataDeExercicio";

const CadInfoBotoes = (props: any) => {
  const navigate = useNavigate();

  function mostrarConfirmar() {

    modalApi.confirm({
      title: props.manter === 1 ? "Deseja confirmar o cadastro?" : "Deseja confirmar as alterações?",
      width: "700px",
      icon: <ExclamationCircleOutlined />,
      content: "Dirigente: " + maskCpf(props.form.getFieldValue("nuCpf")) + " (" + props.form.getFieldValue("nmPessoaFisica") + ")",
      okButtonProps: { id: 'ok' },
      onOk() {
        props.form.validateFields();
        window.scrollTo(0, 0)
        props.form.submit();
      },
      onCancel() { },
    });

  }

  function limparCamposDesabilitar() {
    props.resetForm();

    props.form.setFieldsValue({
      "nuMatriculaEfpc": undefined,
      "nmCargo": undefined,
      "dtInicioMandato": undefined,
      "dtFimMandato": undefined,
      "dtInicioExercicio": undefined,
      "dtFimExercicio": undefined,
    });

    if (window.location.href.includes("conselheiro")){
      navigate("/dirigente/conselheiro/consultar");
    } else {
      navigate("/dirigente/diretor/consultar");
    }
  }

  function confirmarExclusao(){
    modalApi.confirm({
      title: "Exclusão",
      width: "700px",
      icon: <ExclamationCircleOutlined />,
      content: "Deseja excluir esse mandato? Os dados atuais se tornarão indisponíveis.",
      okButtonProps: { id: 'ok' },
      onOk() {
        let pagina = '';
        if (window.location.href.includes("conselheiro")){
          pagina = "mandatoconselheiro";
        } else {
          pagina = "mandatodiretor";
        }

        const idMandato = props.form.getFieldValue("idMandato");

        let lQuery = `${pagina}/${idMandato}`;

        props.setLoading(true);
        apiCand.delete(lQuery).then(()=>{
            props.setLoading(false);
            successMessage("Mandato excluído com sucesso.");
            limparResultadoSalvo('idMandato', idMandato);
            novaConsulta();
        })
        .catch(err=>{
            props.setLoading(false);
            let data: IErroApi = err.response.data;
            let msgErro = data.mensagem ? data.mensagem : err.response.data.message;
            let msgDetalheErro = data.campos ? ". " + data.campos[0].cmensagem : "";
            errorMessage(msgErro + msgDetalheErro);
        });

      },
      onCancel() { },
    });
  }

  function confirmaNovaConsulta() {
    if (props.manter === 3) {
      modalApi.confirm({
        title: "Nova consulta",
        width: "700px",
        icon: <ExclamationCircleOutlined />,
        content: "Deseja abandonar a edição atual? As alterações não salvas serão perdidas",
        okButtonProps: { id: 'ok' },
        onOk() {
          novaConsulta();
        },
        onCancel() { },
      });
    } else novaConsulta();
  }

  function novaConsulta() {
    props.setManter(-1); // ESTADO INICIAL
    limparCamposDesabilitar();
    props.resetColor();
  }

  return (
    <>
      <PageHeader
        className='site-page-header'
        style={{ background: "#FFF" }}
        extra={
          <div
            style={{
              display: "flex",
              width: "max-content",
              justifyContent: "flex-end",
            }}
          >
            <Space>
              <TelaDataDeExercicio form={props.form} botaoVisivel={props.manter === 2} />
              
              <Button
                style={{ display: props.manter === 2 && props.permitirExcluir ? "inline" : "none" }}
                shape='round'
                onClick={() => {
                  confirmarExclusao();
                }}
                type='dashed'
                icon={<DeleteOutlined />}
              >
                Excluir
              </Button>

              <Button
                style={{ display: props.manter >= 2 ? "inline" : "none" }}
                shape='round'
                onClick={() => confirmaNovaConsulta()}
                icon={<ClearOutlined />}
              >
                Nova consulta
              </Button>

              {/* CANCELAR EDIÇÃO */}
              <Button
                style={{ display: props.manter === 3 ? "inline" : "none" }} // SOMENTE PARA EDIÇÃO
                shape='round'
                onClick={() => {
                  props.setManter(2); // ESTADO DETALHAR
                  window.scrollTo(0, 0)
                }}
                icon={<ClearOutlined />}
              >
                Cancelar
              </Button>

              <Button
                style={{ display: props.manter === 2 ? "inline" : "none" }}
                disabled={props.desabilitaBtnEditar ? props.desabilitaBtnEditar() : true}
                shape='round'
                onClick={() => {
                  props.setManter(3);
                }}
                type='primary'
                icon={<ClearOutlined />}
              >
                Editar
              </Button>

              {/* CANCELAR INCLUSÃO */}
              <Button
                style={{ display: (props.manter === 1) ? "inline" : "none" }} // INSERIR 
                // disabled={props.desabilitaBotoes()}
                shape='round'
                onClick={() => {
                  props.setManter(1)
                  if (window.location.href.includes("conselheiro")){
                    navigate("/dirigente/conselheiro/consultarpessoafisica");
                  } else {
                    navigate("/dirigente/diretor/consultarpessoafisica");
                  }
                }}
                icon={<ClearOutlined />}
              >
                Cancelar
              </Button>

              <Button
                style={{ display: (props.manter === 1 || props.manter === 3) ? "inline" : "none" }} // INSERIR OU ALTERAR
                // disabled={props.desabilitaBotoes()}
                shape='round'
                onClick={() => {
                  props.resetColor();
                  mostrarConfirmar();
                }}
                type='primary'
                icon={<CheckOutlined />}
              >
                Salvar
              </Button>

            </Space>
          </div>
        }
      />
    </>
  );
};

export default CadInfoBotoes;
